import React from 'react';
import QueuesAppBase from '@atlassian/jira-spa-apps-queues-app-base/src/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import QueuesIssueViewContent from '@atlassian/jira-spa-apps-servicedesk-queues-issue-view-content/src/ui/content/index.tsx';

export default function QueuesIssueViewSpa() {
	return (
		<UFOSegment name="queues-issue-view-spa">
			<QueuesAppBase pageId="queues-issue-view">
				{({ match, pageContext, push }) =>
					pageContext && (
						<QueuesIssueViewContent
							pageContext={pageContext}
							// @ts-expect-error - TS2322 - Type 'QueuesPush' is not assignable to type '(url: string) => void'.
							push={push}
							match={match}
						/>
					)
				}
			</QueuesAppBase>
		</UFOSegment>
	);
}
